import { ProductBreadcrumbs } from '@core-ui/product-breadcrumbs';
import React, { useContext } from 'react';
import { PageDataContext } from '../../providers/page-data-provider';
import { getStyles } from './style';

type BreadcrumbsCLPType = { isBananaRepublic?: boolean };


const BreadcrumbsCLP = ({ isBananaRepublic = false, ...props } : BreadcrumbsCLPType) => {
  const { breadcrumbs } = useContext(PageDataContext);

  if (breadcrumbs?.length < 3) {
    return null;
  }

  const [division, category, page] = breadcrumbs;
  return (
    <div data-testid="breadcrumbs-clp" css={getStyles(isBananaRepublic)} {...props} >
      <ProductBreadcrumbs
        breadcrumbs={{ division, category, page }}
      />
    </div>
  );
};

export default BreadcrumbsCLP;
